var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7178 14.78C14.0111 15.0733 14.4867 15.0733 14.78 14.78C15.0733 14.4866 15.0733 14.0111 14.78 13.7177L11.0622 10L14.78 6.28226C15.0733 5.98893 15.0733 5.51336 14.78 5.22004C14.4867 4.92671 14.0111 4.92671 13.7178 5.22004L10 8.93778L6.28223 5.21999C5.9889 4.92667 5.51333 4.92667 5.22 5.21999C4.92668 5.51332 4.92668 5.98889 5.22 6.28221L8.9378 10L5.21999 13.7178C4.92667 14.0111 4.92667 14.4867 5.21999 14.78C5.51332 15.0733 5.98889 15.0733 6.28222 14.78L10 11.0622L13.7178 14.78Z",
    fill: "#858C94"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgClose);
export default __webpack_public_path__ + "static/media/svg_close.e7ae78a8a648de1be61a453086272ca0.svg";
export { ForwardRef as ReactComponent };